import React, { useEffect, useRef } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import JaimeRiceImage from '../../assets/images/testimonial/Jaime Rice Headshot.jpeg';
import StephanieSpaldingImage from '../../assets/images/testimonial/Stephanie Spalding Headshot.jpeg';
import ShawnSullivanHeadshotImage from '../../assets/images/testimonial/Shawn Sullivan Headshot.jpeg';
import { Box } from '@mui/material';

// import "./TestimonialCarousel.css"; // Add custom styles if needed
// const testimonials = [
//     {
//       text: "Lorem ipsum dolor sit amet, consectetuer adipiscing...",
//       author: "- Lorem ipsum dolor",
//     },
//     {
//       text: "Sed diam nonummy nibh euismod tincidunt ut laoreet...",
//       author: "- Lorem ipsum dolor",
//     },
//     {
//       text: "Ut wisi enim ad minim veniam, quis nostrud exerci tation...",
//       author: "- Lorem ipsum dolor",
//     },
//   ];
const PrevArrow = (props) => {
    return (
        <div className='testtimonial-wrap'>
            <div className='testtimonial-slider'>
                <button type="button" className="owl-prev"><span aria-label="Previous">‹</span></button>
            </div>
        </div>
    );
};

const NextArrow = (props) => {
    return (
        <div className='testtimonial-wrap'>
            <div className='testtimonial-slider'>
                <button type="button" className="owl-next"><span aria-label="Next">›</span></button>
            </div>
        </div>
    );
};


export default function StartTestimonialSection({ heading} ) {
    const sliderRef = useRef();
    // useEffect(() => {
    //     // if ($(".testimonial-owl").length) {
    //     //     $(".testimonial-owl").owlCarousel({
    //     //     navigation: false,
    //     //     autoplay: false,
    //     //     margin: 20,
    //     //     loop: true,
    //     //     autoplayTimeout: 5000,
    //     //     responsive: {
    //     //         0: { items: 1 },
    //     //         767: { items: 1 },
    //     //         1024: { items: 2 },
    //     //         1366: { items: 2 },
    //     //     },
    //     //     });
    //     // }
    //     if (typeof window !== "undefined") {
    //         // Ensure jQuery is globally available
    //         window.$ = window.jQuery = $;

    //         // Wait for DOM to load
    //         $(document).ready(function () {
    //           $(".testimonial-owl").owlCarousel({
    //             loop: true,
    //             margin: 10,
    //             nav: true,
    //             autoplay: true,
    //             autoplayTimeout: 5000,
    //             responsive: {
    //               0: { items: 1 },
    //               768: { items: 2 },
    //               1024: { items: 3 },
    //             },
    //           });
    //         });
    //       }
    //   }, []);

    // useEffect(() => {
    //     if (typeof window !== "undefined") {
    //       // Ensure jQuery is globally available
    //     //   window.$ = window.jQuery = $;

    //       // Wait for DOM to load
    //       $(document).ready(function () {
    //         $(".testimonial-owl").owlCarousel({
    //           loop: true,
    //           margin: 10,
    //           nav: true,
    //           autoplay: true,
    //           autoplayTimeout: 5000,
    //           responsive: {
    //             0: { items: 1 },
    //             768: { items: 2 },
    //             1024: { items: 3 },
    //           },
    //         });
    //       });
    //     }
    //   }, []);

    // const settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 3000,
    //     arrows: false,
    //     responsive: [
    //       {
    //         breakpoint: 768,
    //         settings: {
    //           slidesToShow: 1,
    //         },
    //       },
    //     ],
    //   };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: false,
        // draggable: false,
        // swipe: false,
        // touchMove: false,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1080, // mobile & tablets
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                },
            },
            {
                breakpoint: 768, // mobile & tablets
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                },
            },
            {
                breakpoint: 666, // mobile & tablets
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                },
            },
        ],
    };

    const testimonials = [
        {
            text: "Snapshot videos are the perfect way to keep our members in the know. They’re quick, easy to digest, and make our updates feel more engaging.",
            author: "Stephanie Spalding",
            organization: "National Association of Neonatal Nurses",
            image: StephanieSpaldingImage,
        },
        {
            text: "Snapshot videos capture memorable moments and highlight Society activities, making members feel connected and involved. They also provide an excellent opportunity to showcase achievements and foster a sense of belonging.",
            author: "Jaime Rice",
            organization: "American Society of Cytopathology",
            image: JaimeRiceImage,
        },
        {
            text: "Snapshot videos are an effective way to keep members engaged throughout the year, with a quick turnaround that keeps content fresh.",
            author: "Shawn Sullivan",
            organization: "American Land Title Association",
            image: ShawnSullivanHeadshotImage,
        },
        // {
        //     text: "ipsum dolor sit amet, consectetuer adipiscing ,sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.",
        //     author: "- Lorem ipsum dolor",
        // },
    ];


    return (
        <>
            <section className="testtimonial-section" id="testtimonial-section" style={ heading && { padding: "0px", paddingTop: "115px" }}>
                <div className="row">
                    <div className="container">
                        <div className="testtimonial-wrap">
                            <div className="title wow zoomIn">
                                {/* <h2>Client <span className="red">Testimonials</span></h2> */}

                                {heading ? <h2 style={heading && { fontSize: "40px" }}>Client <span className="red"> Testimonials</span></h2>
                                    : <h2>What Associations <span className="red"> Are Saying</span></h2>
                                }
                            </div>
                            <div className="testtimonial-slider wow fadeInLeft">
                                <div className="testtimonial-item-wrap testimonial-owl owl-loaded owl-drag" id="testimonial-owl">
                                    {/* <Box className="owl-stage-outer" sx={{ overflow: {xs: "scroll !important", sm: "hidden !important"} }}></Box> */}
                                    <div className="owl-stage-outer">
                                        <Slider {...settings} ref={sliderRef} className="owl-stage" style={{width: {xs :"475px !important", sm:"540px !important", md:"560px !important", lg:"575px !important"}, marginRight: '20px !important'}}>
                                            {testimonials.map((item, index) => (
                                                <div key={index} className="owl-item">
                                                    <div className="testtimonial-item">
                                                        <div className="testtimonial-text">
                                                            <p>
                                                                <span className="semi-colon">
                                                                    <img src="./images/semi-color-image.png" alt="quote" />
                                                                </span> {item.text}
                                                            </p>
                                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', gap: '15px', marginTop: '15px' }}>
                                                                <img 
                                                                    src={item.image} 
                                                                    alt={item.author}
                                                                    style={{ 
                                                                        width: '70px', 
                                                                        height: '70px', 
                                                                        borderRadius: '50%',
                                                                        objectFit: 'cover', 
                                                                        margin: '0px'
                                                                    }} 
                                                                />
                                                                <div>
                                                                    <p style={{ margin: 0, fontWeight: 'bold' }}>{item.author}</p>
                                                                    <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>{item.organization}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                        {/* <Box
                                            className="owl-stage"
                                            // component={'div'}
                                            sx={{
                                                transition: "all",
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: {xs: "column", sm: "row"},
                                                gap: {xs: "70px", sm: "0px"},
                                            }}
                                        >
                                            {testimonials.map((item, index) => (
                                                <div class="owl-item active" style={{ width: "100%" }}>
                                                    <div class="testtimonial-item">
                                                        <div class="testtimonial-text">
                                                            <p>
                                                                {" "}
                                                                <span class="semi-colon">
                                                                {" "}
                                                                <img src="./images/semi-color-image.png" />{" "}
                                                                </span>{" "}
                                                                {item.text}
                                                            </p>
                                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', gap: '15px', marginTop: '15px' }}>
                                                                <img 
                                                                    src={item.image} 
                                                                    alt={item.author}
                                                                    style={{ 
                                                                        width: '70px', 
                                                                        height: '70px', 
                                                                        borderRadius: '50%',
                                                                        objectFit: 'cover', 
                                                                        margin: '0px'
                                                                    }} 
                                                                />
                                                                <div>
                                                                    <p style={{ margin: 0, fontWeight: 'bold' }}>{item.author}</p>
                                                                    <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>{item.organization}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Box> */}
                                    </div>
                                    <div className="owl-nav disabled">
                                        <button type="button" role="presentation" className="owl-prev" onClick={() => sliderRef.current?.slickPrev()} >
                                            <span aria-label="Previous">‹
                                            </span>
                                        </button>
                                        <button type="button" role="presentation" className="owl-next" onClick={() => sliderRef.current?.slickNext()} >
                                            <span aria-label="Next">›

                                            </span>
                                        </button>
                                    </div>
                                    <div className="owl-dots">
                                        <button role="button" className="owl-dot active">
                                            <span>

                                            </span>
                                        </button>
                                        <button role="button" className="owl-dot">
                                            <span>

                                            </span>
                                        </button>
                                        <button role="button" className="owl-dot">
                                            <span>

                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
